<script setup lang="ts">
import Button from "primevue/button";
import { defineEmits, defineProps, withDefaults } from "vue";

interface Props {
  text?: string;
  secondary?: boolean;
  class?: string;
  ariaLabel?: string;
  yellow?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  text: "",
  secondary: false,
  class: "",
  ariaLabel: "",
  yellow: false,
});

const emit = defineEmits<{
  (e: "click"): void;
}>();
</script>

<template>
  <Button
    :class="{
      [props.class]: true,
      'p-button-sec': props.secondary,
      'p-button-yellow': props.yellow,
    }"
    @click="emit('click')"
    :aria-label="props.ariaLabel"
    :tabindex="0"
    :severity="props.secondary ? 'secondary' : 'primary'"
  >
    {{ props.text }}
    <slot />
  </Button>
</template>

<style scoped lang="scss">
.p-button {
  line-height: 24px;
  letter-spacing: 0.42px;
  font-family: var(--font-roboto-bold), sans-serif !important;
  box-sizing: border-box;
  box-shadow: 2px 2px 4px -1px rgba(0, 0, 0, 0.25);

  &.p-button-yellow {
    background-color: var(--color-yellow-400);
    border-color: var(--color-yellow-400);
    color: var(--color-gray-yellow-button);
    transition: background-color 0.3s ease;
    &:hover {
      background-color: var(--color-yellow-300);
      color: var(--color-gray-yellow-button);
      border-color: var(--color-yellow-300);
    }
  }
  &.p-button-sec {
    background-color: var(--color-white);
    color: var(--color-blue-standard);
    &:hover {
      background: var(--color-blue-200);
    }
  }
  &:focus {
    box-shadow: 0 0 0 1px var(--color-white), 0 0 0 3px var(--color-blue-600) !important;
  }
  &:focus-visible {
    box-shadow: 0 0 0 2px var(--color-yellow-300),
      0 0 0 4px var(--color-blue-focus-line) !important;
    background-color: var(--color-yellow-300);
    color: var(--color-gray-900);
    border-color: var(--color-yellow-300);

    &:hover {
      background: var(--color-yellow-300);
      border-color: var(--color-yellow-300);
      color: var(--color-gray-900);
    }
  }
}
</style>
